import { render, staticRenderFns } from "./LucaResultDetail.vue?vue&type=template&id=6316a75a&"
import script from "./LucaResultDetail.vue?vue&type=script&lang=js&"
export * from "./LucaResultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports